import React from "react";
import Settings from "../components/Settings";

const SettingsPage = () => {
  return (
    <div>
      <Settings />
    </div>
  );
};

export default SettingsPage;
